export const keywords = {
    EDIT: "EDIT",
    ADD: "ADD",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
};
